import { jsxs as t, jsx as C } from "react/jsx-runtime";
import { svgIconStyles as i } from "../svg-icon/SvgIcon.styles.js";
function a({
  label: e,
  className: l,
  size: r,
  ...o
}) {
  return /* @__PURE__ */ t(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      "data-title": "createAdFill",
      stroke: "none",
      role: "img",
      "aria-hidden": !e,
      focusable: "false",
      className: i({ className: l, size: r }),
      ...o,
      children: [
        e && /* @__PURE__ */ C("title", { children: e }),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.92895 3.92871C3.7319 4.12576 3.60162 4.37967 3.55647 4.65466L2.68099 9.98716C2.57662 10.6228 2.78484 11.2699 3.24035 11.7254L12.4142 20.8993C13.1953 21.6803 14.4616 21.6803 15.2427 20.8993L20.8995 15.2424C21.6806 14.4614 21.6806 13.195 20.8995 12.414L18.4855 10H18V11C18 12.1046 17.1046 13 16 13C14.8955 13 14 12.1046 14 11V10H13C11.8955 10 11 9.10459 11 8.00002C11 6.89545 11.8955 6.00002 13 6.00002H14V5.5145L11.7256 3.24011C11.2701 2.78459 10.6231 2.57638 9.9874 2.68074L4.65491 3.55623C4.37991 3.60138 4.126 3.73165 3.92895 3.92871ZM9.58582 7.46449C10.1716 8.05027 10.1716 9.00002 9.58582 9.58581C9.00003 10.1716 8.05029 10.1716 7.4645 9.58581C6.87871 9.00002 6.87871 8.05027 7.4645 7.46449C8.05029 6.8787 9.00003 6.8787 9.58582 7.46449Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M12.0203 7.79849C12.1136 7.34279 12.5168 7 13 7H15V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V7H19C19.5523 7 20 7.44771 20 8C20 8.55228 19.5523 9 19 9L17 9.00002V11C17 11 17 11 17 11C17 11.069 16.993 11.1365 16.9797 11.2016C16.8865 11.6572 16.4833 12 16 12C15.5661 12 15.1967 11.7236 15.0583 11.3373C15.0206 11.2319 15 11.1184 15 11C15 11 15 11 15 11V9.00002H13C12.5675 9.00002 12.199 8.72536 12.0596 8.34092C12.0211 8.23453 12 8.11973 12 8.00002",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M12 8.00002C12 7.93099 12.007 7.86358 12.0203 7.79849L12 8.00002Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
export {
  a as CreateAdFillIcon,
  a as default
};
